function addObjectiveToCategory(
  categories,
  objectifs,
  showHiddenValues = false
) {
  try {
    let sumOfAutomaticValues = 0;

    const addObjective = (category, objectif) => {
      if (category.isRacine) return false;

      if (Number(category.id) === Number(objectif.categoryId)) {
        category.objectif = objectif;
        return true;
      }

      if (category.children) {
        for (const child of category.children) {
          if (addObjective(child, objectif)) {
            return true;
          }
        }
      }
      return false;
    };

    objectifs.forEach((objectif) => {
      for (const category of categories) {
        if (addObjective(category, objectif)) {
          break;
        }
      }
    });

    const updateCategories = (categories) => {
      return categories
        .map((category) => {
          if (category.isRacine) return category;

          // NEW LOGIC: if showHiddenValues is true and this is a masked category, return the object directly!
          if (!showHiddenValues && category.isMasked) {
            return category;
          }

          // Old logic follows as fallback (when not masked, or showHiddenValues false)
          const updatedCategory = { ...category };

          if (updatedCategory.children) {
            const updatedChildren = updateCategories(
              updatedCategory.children
            ).filter(Boolean);

            // Filter logic when showHiddenValues is true:
            // - Keep masked categories that have objectif amount (2nd case)
            // - Remove masked categories with no objectif amount (3rd case)
            const childrenToConsider = showHiddenValues
              ? updatedChildren.filter((child) => {
                  return !child.isMasked || child.objectif?.amount != null;
                })
              : updatedChildren;

            // -- Enhancement: Keep reference to all children for special alert logic!
            const allChildren = updatedChildren;

            const doesAnyOfTheChildrenHasObjective = childrenToConsider.some(
              (child) =>
                child.objectif?.amount != null || child.hasAutomaticValue
            );

            const AnyChildHasAutomaticValue = childrenToConsider.some(
              (child) => child.hasAutomaticValue
            );

            const hasObjectif =
              !!category.objectif && updatedCategory?.objectif?.amount;

            const totalChildrenValue = childrenToConsider.reduce(
              (sum, child) => {
                return (
                  sum +
                  (child.objectif?.amount
                    ? parseFloat(child.objectif.amount)
                    : 0)
                );
              },
              0
            );

            if (updatedCategory.levelId === 1) {
              const AnyCategoryOf1stHasChild = categories.some((category) => {
                return category.objectif && category.levelId === 1;
              });

              if (
                AnyCategoryOf1stHasChild &&
                !AnyChildHasAutomaticValue &&
                !hasObjectif
              ) {
                updatedCategory.notMentioned = true;
              }
            }

            if (updatedCategory.levelId !== 1) {
              const anychildHasObjectif = categories.some((category) => {
                return category.objectif?.amount != null;
              });

              if (anychildHasObjectif && !hasObjectif) {
                updatedCategory.notMentioned = true;
              }
            }

            updatedCategory.children = updatedChildren;

            updatedCategory.hasAutomaticValue =
              doesAnyOfTheChildrenHasObjective && !hasObjectif;

            updatedCategory.automaticValue = totalChildrenValue;

            if (AnyChildHasAutomaticValue && !hasObjectif) {
              updatedCategory.notMentioned = false;
              updatedCategory.hasAutomaticValue = true;
            }

            if (updatedCategory.hasAutomaticValue) {
              updatedCategory.notMentioned = false;
            }

            const sumOfAutomaticChildren = childrenToConsider.reduce(
              (acc, child) => {
                if (child.hasAutomaticValue && child.automaticValue) {
                  acc += child.automaticValue;
                }
                return acc;
              },
              0
            );

            updatedCategory.automaticValue = updatedCategory.automaticValue;

            const hasValueMismatch =
              hasObjectif &&
              childrenToConsider.length > 0 &&
              doesAnyOfTheChildrenHasObjective &&
              parseFloat(category?.objectif?.amount) !==
                totalChildrenValue + sumOfAutomaticChildren;

            if (hasValueMismatch) {
              let difference = category.objectif.amount
                ? parseFloat(category.objectif.amount) -
                  totalChildrenValue -
                  sumOfAutomaticChildren
                : -totalChildrenValue + sumOfAutomaticChildren;

              if (difference !== 0) {
                const existingRacineCategory = updatedChildren.find(
                  (child) => child.isRacine === true
                );

                if (existingRacineCategory) {
                  existingRacineCategory.objectif = {
                    amount: difference.toFixed(2),
                  };
                } else {
                  const racineCategory = {
                    id: `racine-${category.id}`,
                    name: `Racine de ${category.name}`,
                    categoryId: category.id,
                    isSpecial: category?.isSpecial,
                    isRacine: true,
                    objectif: {
                      amount: difference.toFixed(2),
                    },
                    levelId: updatedCategory.levelId + 1,
                    children: [],
                    isMasked: category.isMasked,
                  };

                  updatedCategory.hasAlert = true;

                  updatedChildren.unshift(racineCategory);
                }
              }
            }

            if (updatedCategory.hasAutomaticValue) {
              const sumOfDirectChildrenAutomaticValues =
                updatedCategory.automaticValue +
                childrenToConsider.reduce((sum, child) => {
                  if (child.hasAutomaticValue) {
                    return sum + (child.automaticValue || 0);
                  }
                  return sum;
                }, 0);

              updatedCategory.automaticValue =
                sumOfDirectChildrenAutomaticValues;
            }

            // === ALERT LOGIC REWRITE START ===
            // Original:
            // updatedCategory.hasAlert =
            //   childrenToConsider.some((child) => child.notMentioned) ||
            //   hasValueMismatch;
            //
            // New: When showHiddenValues is true, check if any masked child (even excluded from childrenToConsider)
            // is "notMentioned" and has UNmasked siblings with values. In that case, trigger hasAlert!

            let hasSpecialMaskedNotMentionedAlert = false;
            if (showHiddenValues) {
              // Check original (all) children: for any masked child that's notMentioned and has visible siblings w/ values...
              for (let child of allChildren) {
                if (
                  child.isMasked &&
                  child.notMentioned &&
                  // There is at least one UNmasked or unmasked+with value sibling (not itself) with value
                  allChildren.some(
                    (sibling) =>
                      sibling !== child &&
                      !sibling.isMasked &&
                      (sibling.objectif?.amount != null ||
                        sibling.hasAutomaticValue)
                  )
                ) {
                  hasSpecialMaskedNotMentionedAlert = true;
                  break;
                }
              }
            }

            updatedCategory.hasAlert =
              childrenToConsider.some((child) => child.notMentioned) ||
              hasValueMismatch ||
              hasSpecialMaskedNotMentionedAlert;
            // === ALERT LOGIC REWRITE END ===

            updatedCategory.children = updatedChildren;
          }

          return updatedCategory;
        })
        .filter(Boolean); // Remove all nulls resulting from filtered-out categories
    };

    const updatedCategoriesWithObjectives = updateCategories(categories);

    // Filter level one categories: if showHiddenValues is true, remove masked level 1 categories (1st case)
    const levelOneCategories = updatedCategoriesWithObjectives.filter(
      (category) => {
        if (category.levelId !== 1) return false;
        // If showHiddenValues is true and category is level 1 and masked, remove it (1st case)
        if (showHiddenValues && category.isMasked) return false;
        return true;
      }
    );

    // Footer / export total: sum of L1 displayed budgets (stored amount OR auto rollup).
    sumOfAutomaticValues = levelOneCategories.reduce((acc, elem) => {
      if (elem?.objectif?.amount) {
        return acc + parseFloat(elem.objectif.amount);
      }
      if (elem?.hasAutomaticValue) {
        return acc + (elem?.automaticValue || 0);
      }
      return acc;
    }, 0);

    // Improvement: doesAnyOflevelOnenotMentioned must also catch level-1 categories with hasAlert
    let doesAnyOflevelOnenotMentioned = levelOneCategories.some(
      (category) => category.hasAlert === true || category.notMentioned === true
    );

    return {
      updatedCategoriesWithObjectives,
      sumOfAutomaticValues,
      doesAnyOflevelOnenotMentioned,
    };
  } catch (error) {
    console.log({ error });
  }
}
// plan comptable
function addObjectiveToPlanComptable(
  categories,
  objectifs,
  showHiddenValues = false
) {
  try {
    let sumOfAutomaticValues = 0;

    // Clear out any previously set objectif and related fields
    const clearObjectives = (categoryList) => {
      return categoryList.map((category) => {
        const clearedCategory = { ...category };

        delete clearedCategory.objectif;
        delete clearedCategory.hasAutomaticValue;
        delete clearedCategory.automaticValue;
        delete clearedCategory.notMentioned;
        delete clearedCategory.hasAlert;

        if (clearedCategory.children) {
          clearedCategory.children = clearObjectives(clearedCategory.children);
        }

        return clearedCategory;
      });
    };

    const clearedCategories = clearObjectives(categories);

    // Assign objectifs according to .planComptableId
    const addObjective = (category, objectif) => {
      if (category.isRacine) return false;

      if (Number(category.id) === Number(objectif.planComptableId)) {
        category.objectif = objectif;
        return true;
      }

      if (category.children) {
        for (const child of category.children) {
          if (addObjective(child, objectif)) return true;
        }
      }
      return false;
    };

    if (objectifs && objectifs.length > 0) {
      objectifs.forEach((objectif) => {
        for (const category of clearedCategories) {
          if (addObjective(category, objectif)) break;
        }
      });
    }

    const updateCategories = (categories) => {
      return categories
        .map((category) => {
          if (category.isRacine) return category;

          // Continue processing all categories (including masked ones)
          const updatedCategory = { ...category };

          if (updatedCategory.children) {
            const updatedChildren = updateCategories(
              updatedCategory.children
            ).filter(Boolean);

            // Apply logic for filtering which children to consider
            const childrenToConsider = showHiddenValues
              ? updatedChildren.filter((child) => {
                  return !child.isMasked || child.objectif?.amount != null;
                })
              : updatedChildren;

            const doesAnyOfTheChildrenHasObjective = childrenToConsider.some(
              (child) =>
                child.objectif?.amount != null || child.hasAutomaticValue
            );

            const AnyChildHasAutomaticValue = childrenToConsider.some(
              (child) => child.hasAutomaticValue
            );

            const hasObjectif =
              !!category.objectif && updatedCategory?.objectif?.amount;

            const totalChildrenValue = childrenToConsider.reduce(
              (sum, child) => {
                return (
                  sum +
                  (child.objectif?.amount
                    ? parseFloat(child.objectif.amount)
                    : 0)
                );
              },
              0
            );

            // Level one "notMentioned" logic
            if (updatedCategory.levelId === 1) {
              const AnyCategoryOf1stHasChild = categories.some((category) => {
                return category.objectif && category.levelId === 1;
              });

              if (
                AnyCategoryOf1stHasChild &&
                !AnyChildHasAutomaticValue &&
                !hasObjectif
              ) {
                // If level one category (masked or not) is not mentioned, set notMentioned to true
                updatedCategory.notMentioned = true;
              }
            }

            if (updatedCategory.levelId !== 1) {
              const anychildHasObjectif = categories.some((category) => {
                return category.objectif?.amount != null;
              });

              if (anychildHasObjectif && !hasObjectif) {
                updatedCategory.notMentioned = true;
              }
            }

            updatedCategory.children = updatedChildren;

            updatedCategory.hasAutomaticValue =
              doesAnyOfTheChildrenHasObjective && !hasObjectif;

            updatedCategory.automaticValue = totalChildrenValue;

            if (AnyChildHasAutomaticValue && !hasObjectif) {
              updatedCategory.notMentioned = false;
              updatedCategory.hasAutomaticValue = true;
            }

            if (updatedCategory.hasAutomaticValue) {
              updatedCategory.notMentioned = false;
            }

            // For masked categories: if they have no objectif and no automatic value, mark as notMentioned
            if (
              updatedCategory.isMasked &&
              !hasObjectif &&
              !updatedCategory.hasAutomaticValue &&
              showHiddenValues
            ) {
              updatedCategory.notMentioned = true;
            }

            const sumOfAutomaticChildren = childrenToConsider.reduce(
              (acc, child) => {
                if (child.hasAutomaticValue && child.automaticValue) {
                  acc += child.automaticValue;
                }
                return acc;
              },
              0
            );

            updatedCategory.automaticValue = updatedCategory.automaticValue;

            const hasValueMismatch =
              hasObjectif &&
              childrenToConsider.length > 0 &&
              doesAnyOfTheChildrenHasObjective &&
              parseFloat(category?.objectif?.amount) !==
                totalChildrenValue + sumOfAutomaticChildren;

            if (hasValueMismatch) {
              let difference = category.objectif.amount
                ? parseFloat(category.objectif.amount) -
                  totalChildrenValue -
                  sumOfAutomaticChildren
                : -totalChildrenValue + sumOfAutomaticChildren;

              if (difference !== 0) {
                const existingRacineCategory = updatedChildren.find(
                  (child) => child.isRacine === true
                );

                if (existingRacineCategory) {
                  existingRacineCategory.objectif = {
                    amount: difference.toFixed(2),
                  };
                } else {
                  const racineCategory = {
                    id: `racine-${category.id}`,
                    name: `Racine de ${category.name}`,
                    categoryId: category.id,
                    isSpecial: category?.isSpecial,
                    isRacine: true,
                    objectif: {
                      amount: difference.toFixed(2),
                    },
                    levelId: updatedCategory.levelId + 1,
                    children: [],
                    isMasked: category.isMasked,
                  };

                  updatedCategory.hasAlert = true;

                  updatedChildren.unshift(racineCategory);
                }
              }
            }

            if (updatedCategory.hasAutomaticValue) {
              const sumOfDirectChildrenAutomaticValues =
                updatedCategory.automaticValue +
                childrenToConsider.reduce((sum, child) => {
                  if (child.hasAutomaticValue) {
                    return sum + (child.automaticValue || 0);
                  }
                  return sum;
                }, 0);

              updatedCategory.automaticValue =
                sumOfDirectChildrenAutomaticValues;
            }

            // Set alert if any child is not mentioned or there's a value mismatch
            // Check all children (not just childrenToConsider) for notMentioned status
            updatedCategory.hasAlert =
              updatedChildren.some(
                (child) => child.notMentioned || child.hasAlert
              ) || hasValueMismatch;

            updatedCategory.children = updatedChildren;
          }

          return updatedCategory;
        })
        .filter(Boolean); // Remove all nulls resulting from filtered-out categories
    };

    const updatedPlanComptablesWithObjectives =
      updateCategories(clearedCategories);

    // Filter level one categories: if showHiddenValues is true, remove masked level 1 categories (1st case)
    const levelOneCategories = updatedPlanComptablesWithObjectives.filter(
      (category) => {
        return category.levelId === 1 && !(showHiddenValues && category.isMasked);
      }
    );

    // Footer / export total: sum of L1 displayed budgets (stored amount OR auto rollup).
    sumOfAutomaticValues = levelOneCategories.reduce((acc, elem) => {
      if (elem?.objectif?.amount) {
        return acc + parseFloat(elem.objectif.amount);
      }
      if (elem?.hasAutomaticValue) {
        return acc + (elem?.automaticValue || 0);
      }
      return acc;
    }, 0);

    // Check if any level one category has alert or is not mentioned
    let doesAnyOflevelOnenotMentioned = levelOneCategories.some((category) => {
      return category.hasAlert === true || category.notMentioned === true;
    });

    return {
      updatedPlanComptablesWithObjectives,
      sumOfAutomaticValues,
      doesAnyOflevelOnenotMentioned,
    };
  } catch (error) {
    console.log({ error });
  }
}

export { addObjectiveToCategory, addObjectiveToPlanComptable };
